<template>
  <div>
    <v-dialog persistent v-model="deleteDialog" max-width="400px">
      <v-card>
        <v-card-title class="headline"
          >Are you sure you want to delete this Todo?</v-card-title
        >
        <v-card-text>
          Todo <strong v-if="itemToDelete">{{ itemToDelete.name }}</strong> will
          be deleted.</v-card-text
        >
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat="flat" @click="cancelDelete">No</v-btn>
          <v-btn color="red darken-1" flat="flat" @click="deleteItem"
            >Yes</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-card class="mx-4 px-3 mt-2 pt-5 elevation-0">
      <v-card-title class="pl-0 my-0 py-0">
        <!-- <v-flex class="display-1 mb-3 mx-0 xs12"> -->
        <!-- User Activity -->
        <!-- <v-spacer></v-spacer> -->
        <!-- <v-layout row my-3 mx-1> -->
        <span>
          <v-menu
            offset-y
            :close-on-content-click="true"
            class="text-xs-right mx-4 my-0 py-0 align-center"
          >
            <template v-slot:activator="{ on }">
              <v-btn
                small
                icon
                color="black"
                dark
                v-on="on"
                class="text-xs-right mx-0 mt-2 my-0 py-0"
              >
                <v-icon small>supervisor_account</v-icon>
              </v-btn>
            </template>
            <v-list value="3">
              <v-list-tile
                v-for="(item, index) in assignedUsers"
                :key="item.id"
                @click="toggleUser(item.id)"
              >
                <!-- <v-list-tile-avatar v-if="item.id==sorting">
                    <v-icon>mdi-sort-ascending</v-icon>
                  </v-list-tile-avatar> -->
                <!-- <v-list-tile-avatar v-else>
                    <v-icon></v-icon>
                  </v-list-tile-avatar> -->
                <v-list-tile-title>{{ item.abb }}</v-list-tile-title>
              </v-list-tile>
            </v-list>
          </v-menu>
        </span>
        <span class="text-xs-left mt-2 pt-1 title" v-show="selectedUser">
          {{ selectedUser.abb }}
        </span>

        <v-btn-toggle v-model="myTodos" class="mt-0 ml-0" small>
          <v-btn
            flat
            small
            key="group1"
            class="px-3"
            :input-value="true"
            :value="true"
          >
            <span>My</span>
          </v-btn>
          <v-btn
            flat
            small
            key="group2"
            class="px-3"
            :input-value="false"
            :value="false"
          >
            <span>All</span>
          </v-btn>
        </v-btn-toggle>
        <v-btn-toggle v-model="visibility" class="mt-0 ml-3" small>
          <v-btn
            flat
            small
            key="group1"
            class="px-3"
            input-value="active"
            value="active"
          >
            <span>Active</span>
          </v-btn>
          <v-btn
            flat
            small
            key="group2"
            class="px-3"
            input-value="all"
            value="all"
          >
            <span>All</span>
          </v-btn>
          <v-btn
            flat
            small
            key="group3"
            class="px-3"
            input-value="completed"
            value="completed"
          >
            <span>Done</span>
          </v-btn>
        </v-btn-toggle>
        <!-- <v-switch class="right" label="Only my Todos" v-model="myTodos"></v-switch> -->
        <!-- </v-flex> -->

        <v-spacer></v-spacer>

        <v-btn
          small dark
          color="black"
          class="mr-3 mt-3"
          @click="exportToExcel"
        >
          <v-icon small left>mdi-file-excel</v-icon>
          Export to Excel
        </v-btn>

        <v-text-field
          class="mb-3"
          v-if="this.$store.state.showSearch"
          prepend-inner-icon="search"
          label="Search "
          single-line
          hide-details
          clearable
          v-model="search"
        ></v-text-field>
        <!-- </v-layout> -->
      </v-card-title>

      <!-- v-model="todo_store" -->
      <v-data-table
        style="border-top: 1px solid #ccc"
        :pagination.sync="pagination"
        hide-headers
        :headers="headers"
        :items="filteredTodos"
        :search="search"
        item-key="id"
        must-sort
        expand
        :loading="$store.state.loading_todos"
        rows-per-page-text="Todos per page"
        no-results-text="No Todos match the criteria."
        class="elevation-0"
      >
        <template slot="items" slot-scope="props">
          <tr class="pb-0 mb-0">
            <td colspan="5" style="padding: 0px">
              <table style="width: 100%; margin: 0px">
                <tr
                  :class="{
                    black: props.expanded,
                    'white--text': props.expanded,
                  }"
                >
                  <!-- <td :class="{title: true, editBG: props.expanded}">{{props.item.created_at}}</td> -->
                  <td class="py-0 my-0 title" colspan="4">
                    <!-- <h3 class="my-2 title"> -->
                    {{ props.item.title }}
                  </td>
                </tr>
                <tr>
                  <!-- padding-left: 0px !important; -->
                  <td
                    class="text-xs-left"
                    style="
                      padding-top: 0px !important;
                      padding-right: 0px !important;
                      height: 30px;
                      width: 30px !important;
                    "
                  >
                    <v-checkbox
                      class="
                        pt-1
                        px-0
                        mx-0
                        align-start
                        justify-start
                        row
                        fill-height
                      "
                      color="black"
                      hide-details
                      v-model="props.item.done"
                      @change="done_todo(props.item)"
                    ></v-checkbox>
                  </td>
                  <td
                    class="text-xs-left"
                    style="padding-top: 0px !important; height: 30px"
                  >
                    <b v-if="props.item.artwork">{{
                      props.item.artwork.title
                    }}</b
                    >,
                    <span v-if="props.item.artwork">{{
                      props.item.artwork.accession_number
                    }}</span>
                    <!-- <router-link class="mr-3" :to="{ name: 'EditExhibition', params: {id: props.item.id, exhibition: props.item}, path: `/exhibitions/edit/${props.item.id}`}" v-html="props.item.title"></router-link> -->
                    <!-- <a v-bind:href="'http://tb-cms.org/exhibitions/edit/' + props.item.id" style="" icon><v-icon small>open_in_new</v-icon></a> -->
                  </td>
                  <td
                    class="text-xs-center"
                    style="
                      width: 130px;
                      padding-top: 0px !important;
                      height: 30px;
                    "
                  >
                    <span class="body-1">{{
                      format_date(props.item.created_at)
                    }}</span>
                  </td>
                  <td
                    class="text-xs-center"
                    style="
                      width: 50px;
                      padding-top: 0px !important;
                      height: 30px;
                    "
                  >
                    <span
                      v-if="props.item.created_by && props.item.created_by > 0"
                      >{{ get_abb(props.item.created_by) }}</span
                    >
                    <span v-else class="px-1"> – </span>
                  </td>
                  <!-- <td
                    class="text-xs-center pt-1"
                    style="
                      width: 50px;
                      padding-top: 0px !important;
                      height: 30px;
                    "
                  > -->
                  <!-- <v-tooltip bottom class="mr-0">
                      <template v-slot:activator="{ on }">
                        <v-btn
                          color="black"
                          icon
                          small
                          @click="loadTodo(props.item.artworks)"
                          v-on="on"
                        >
                          <v-icon small color="white">apps</v-icon>
                        </v-btn>
                      </template>
                      <span>Replace Current Todo with this saved Todo</span>
                    </v-tooltip>

                    <v-tooltip bottom class="mr-4">
                      <template v-slot:activator="{ on }">
                        <v-btn
                          color="black"
                          icon
                          small
                          @click="addToTodo(props.item.artworks)"
                          v-on="on"
                        >
                          <v-icon small color="white">add</v-icon>
                        </v-btn>
                      </template>
                      <span>Add Artworks in this Todo to current Todo</span>
                    </v-tooltip>

                    <v-tooltip bottom class="mr-4">
                      <template v-slot:activator="{ on }">
                        <v-btn color="black" icon small @click="goToList()" v-on="on">
                          <v-icon small color="white">list</v-icon>
                        </v-btn>
                      </template>
                      <span>Go to List and load Current Todo</span>
                    </v-tooltip> -->

                  <!-- <list-action-menu :item="props.item"></list-action-menu> -->

                  <!-- <v-btn icon small @click="props.expanded = !props.expanded">
                      <v-icon
                        v-if="!props.expanded"
                        :class="{ 'white--text': props.expanded }"
                        >expand_more</v-icon
                      >
                      <v-icon
                        v-if="props.expanded"
                        :class="{ 'white--text': props.expanded }"
                        >expand_less</v-icon
                      >
                    </v-btn> -->
                  <!-- </a>  -->
                  <!-- <v-btn
                      v-if="c_user.edit || c_user.delete_rights"
                      icon
                      small
                      @click="delete_todo(props.item)"
                    >
                      <v-icon class="" color="red" small>delete</v-icon>
                    </v-btn> -->
                  <!-- </h3> -->
                  <!-- <v-chip v-for="a in props.item.exhibition_artworks" v-bind:key="a.id" small >{{a.id}}</v-chip> -->
                  <!-- </td> -->
                </tr>
              </table>
            </td>
            <td
              class="text-xs-right pt-1"
              style="width: 20px; padding-top: 0px !important; height: 30px"
            >
              <v-btn
                v-if="c_user.edit || c_user.delete_rights"
                icon
                small
                @click="delete_todo(props.item)"
              >
                <v-icon color="red" small>delete</v-icon>
              </v-btn>
            </td>
          </tr>
        </template>

        <v-alert slot="no-results" :value="true" color="error" icon="warning">
          Your search for "{{ search }}" found no results.
        </v-alert>
        <template slot="no-data">
          <index-load-state
            :loading="$store.state.loading_todos"
            :error="$store.state.load_errors.todos"
            empty-text="No Todos Found."
          ></index-load-state>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import axios from '@/utils/apiClient'
import XLSX from 'xlsx'
// import ListRelated from "./ListRelated";
// import ListActionMenu from "../artworks/ListActionMenu";
import { serverBus } from '../../main'
import IndexLoadState from '@/components/general/IndexLoadState.vue'
// import IndexTable from '@/components/todos/IndexTable'
export default {
  components: { IndexLoadState },
  data: function () {
    return {
      userFilter: null,
      selectedUser: {},
      selectedUsers: [],
      visibility: 'active',
      active_todos: [],
      itemToDelete: {},
      deleteDialog: false,
      // todo_store: [],
      myTodos: false,
      pagination: {
        descending: true,
        rowsPerPage: 10,
        sortBy: 'created_at',
      },
      pagination_related: {
        descending: true,
        // rowsPerPage: 10,
        sortBy: 'title',
      },
      search: '',
      search_related: '',
      selected: [],
      selected_related: [],
      headers: [
        { text: 'Todo', value: 'title' },
        { text: 'Artwork Title', value: 'artwork.title', align: 'left' },
        {
          text: 'Accession No.',
          value: 'artwork.accession_number',
          align: 'left',
        },
        { text: 'Date Created', value: 'created_at', align: 'center' },
        { text: 'Created By', value: 'created_by', align: 'center' },
        { text: '', align: 'right' },
      ],
      headers_related: [
        { text: 'Artwork Title', sortable: true, value: 'title' },
        { text: 'Accession Number', value: 'accession_number', align: 'right' },
        // { text: '', sortable:false, align: 'right' },
        // { text: 'Artist', value: 'artist_name', align: 'right' }
        // { text: 'End', value: 'duration_end', align: 'center', }
        // { text: 'Tags', value: 'tags', sortable: false }
      ],
      table_lists: this.$store.state.lists,
      loading: false,
      displayedData: [],
      filteredTextArtwork: '',
      filteredTextArtist: '',
      selectedFilter: '',
      artwork: {
        name: '',
      },
      artists: [],
      artworks: [],
      resultsArtworks: [],
      resultsArtists: [],
      editArtwork: false,
      filterText: '',
    }
  },
  created: function () {
    serverBus.$on('setSorting', (a) => {
      this.pagination.sortBy = a
      this.pagination.descending = !this.pagination.descending
    })
    this.$store.dispatch('loadTodos')
    // this.$store.dispatch('loadArtworks')
    // this.todo_store = this.$store.state.lists
  },
  methods: {
    exportToExcel() {
      // Prepare data for export
      const data = this.filteredTodos.map(todo => ({
        'Todo': todo.title,
        'Status': todo.done === 1 ? 'Done' : 'Pending',
        'Date done': todo.done_at,
        'Artwork Title': todo.artwork_id ? (() => {
          const artwork = this.$store.state.artworks.find(a => a.id === todo.artwork_id);
          return artwork ? artwork.title : 'Artwork not found';
        })() : 'Not set',
        'Accession No.': todo.artwork_id ? (() => {
          const artwork = this.$store.state.artworks.find(a => a.id === todo.artwork_id);
          return artwork ? artwork.accession_number : 'Artwork not found';
        })() : 'Not set',
        'Description': todo.description,
        'Date Created': todo.created_at,
        'Created By': todo.created_by ? (() => {
          const user = this.$store.state.users.find(u => u.id === todo.created_by);
          return user ? user.firstname + ' ' + user.lastname : 'User not found';
        })() : 'Not set'
      }))

      // Create worksheet
      const ws = XLSX.utils.json_to_sheet(data)
      
      // Create workbook
      const wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, ws, 'Todos')
      
      // Generate Excel file
      XLSX.writeFile(wb, `todos_${new Date().toISOString().split('T')[0]}.xlsx`)
    },
    toggleUser(u) {
      this.userFilter = u
      if (!this.selectedUsers.includes(u)) {
        this.selectedUsers.push(u)
      }
    },
    delete_todo(todo) {
      let url = `${this.$globals.apiserver}/artwork_todos/${todo.id}.json`
      axios
        .delete(url, todo)
        .then((response) => {
          this.errors = {}
          const index = this.todos.indexOf(todo)
          if (index >= 0) this.todos.splice(index, 1)
          // this.artwork.artwork_todos.push(response.data);
          // this.artwork.artwork_todos = [
          //   ...this.artwork.artwork_todos.map(item =>
          //     item.id !== this.todo.id ? item : { ...item, ...this.todo }
          //   )
          // ];
          // console.log(this.artwork.artwork_todos);
          // this.todos = this.artwork.artwork_todos;
          // this.all_todos = Object.assign([],this.artwork.artwork_todos)
          // this.active_todos.push(response.data);
          // this.todos.push(response.data);
          // this.editing = false;
          this.$store.dispatch('updateArtwork', todo.artwork_id)
          this.$store.dispatch('loadTodos')
          this.$store.dispatch('loadArtworks')
          // this.artwork = this.$store.state.artworks.find(
          //   a => (a.id = this.artwork.id)
          // );
        })
        .catch((error) => {
          this.errors = error.response.data
        })
    },
    done_todo(tt) {
      this.$emit('showSnackbar', 'Toggling Todo.', 'black')
      // const todoIndex = this.todos.indexOf(t);
      // console.log(tt)
      var t = Object.assign({}, tt)
      if (t.done == 0 || t.done == '') {
        t.done = 1
        t.done_at = this.format_date(Date.now())
      } else {
        t.done = 0
        t.done_at = null
      }
      let url = `${this.$globals.apiserver}/artwork_todos/${t.id}.json`
      // this.$store.dispatch('toggleTodo', t)
      axios
        .put(url, {
          todo: { done: t.done, done_at: t.done_at },
        })
        .then((response) => {
          this.$emit('showSnackbar', 'Todo saved.', 'green')
          // console.log('after axios')
          this.$store.dispatch('loadTodos')
          this.errors = {}
          // this.artwork.artwork_todos.push(response.data);
          // this.todos = [
          //   ...this.todos.map(item =>
          //     item.id !== this.todo.id ? item : { ...item, ...this.todo }
          //   )
          // ];
          // console.log(this.artwork.artwork_todos);
          // this.todos = this.artwork.artwork_todos;
          // this.all_todos = Object.assign([],this.artwork.artwork_todos)
          // this.active_todos.push(response.data);
          // this.todos.push(response.data);
          this.editing = false
          // this.$store.dispatch("updateArtwork", this.artwork.id);
          // this.artwork = this.$store.state.artworks.find(
          //   a => (a.id = this.artwork.id)
          // );
        })
        .catch((error) => {
          this.errors = error.response.data
        })
      // this.editing = false;
    },
    goToList() {
      this.$router.push({
        name: 'Lists',
        params: { loadCurrent: '1' },
      })
    },
    loadTodo(e) {
      // console.log(e)
      // console.log(add)
      // if (add) {
      //   // console.log('add')
      this.$store.dispatch('saveCurrentTodo', e)
      // } else {
      //   // console.log('no add')
      //   this.$store.dispatch('addToCurrentTodo',e)
      // }
    },
    addToTodo(e) {
      // console.log(e)
      // console.log(add)
      // if (add) {
      //   // console.log('add')
      // this.$store.dispatch('saveCurrentTodo',e)
      // } else {
      //   // console.log('no add')
      this.$store.dispatch('addToCurrentTodo', e)
      // }
    },

    showDeleteDialog(p) {
      this.itemToDelete = p
      this.deleteDialog = true
    },
    deleteItem() {
      const index = this.todos.indexOf(this.itemToDelete)
      var i = this.todos.indexOf(this.itemToDelete)
      // if (i != -1) {
      //   this.todos.splice(i, 1);
      // }
      // confirm('Are you sure you want to delete this item?') && this.desserts.splice(index, 1)
      this.$store.dispatch('deleteTodo', this.itemToDelete)
      this.itemToDelete = null
      this.deleteDialog = false
    },
    cancelDelete() {
      this.deleteDialog = false
      this.itemToDelete = null
    },
    remove_from_todo(list_id, artwork_id) {
      var list = Object.assign(
        {},
        this.$store.state.lists.find((list) => list.id == list_id)
      )
      list.artworks = list.artworks.filter((a) => a != artwork_id)
      this.$store.dispatch('removeArtworkFromList', {
        l: list_id,
        a: artwork_id,
      })
    },
    table_artworks(as) {
      return this.$store.state.artworks.filter((a) => as.includes(a.id))
    },
  },
  computed: {
    assignedUsers() {
      var out = this.todos
        .map((t) => (t.users.length > 0 ? t.users.map((u) => u.id) : null))
        .filter((o) => o != null)
        .flat()
      let unique = [...new Set(out)]
      let out2 = this.$store.state.users.filter((u) => unique.includes(u.id))
      return out2
    },
    filteredTodos: function () {
      let afterStatusFilter = []
      if (this.visibility == 'all') {
        afterStatusFilter = this.todos
      } else if (this.visibility == 'active') {
        afterStatusFilter = this.todos.filter((t) => t.done != 1)
      } else if (this.visibility == 'completed') {
        afterStatusFilter = this.todos.filter((t) => t.done == 1)
      }
      if (this.userFilter) {
        return afterStatusFilter.filter(
          (t) =>
            // t.created_by == this.userFilter ||
            t.users && t.users.map((u) => u.id).includes(this.userFilter)
        )
      } else {
        return afterStatusFilter
      }
    },
    todos() {
      // this.c_user.id
      var a = []
      if (this.myTodos) {
        // return this.todo_store.filter(j => j.created_by === this.c_user.id)
        a = this.$store.getters.user_todos
      } else {
        a = this.$store.state.todos
      }
      // Results.map(obj=> ({ ...obj, Active: 'false' }))

      return a.map((aa) => ({
        ...aa,
        artwork: this.$store.state.artworks.find(
          (aaa) => aaa.id == aa.artwork_id
        ),
      }))
    },
    // table_lists () {
    // return this.todo_store
    // return this.$store.state.lists
    // },
    filtered() {
      return this.$store.state.filterResults
    },
    title() {
      let title = ''
      // if (this.$route.fullPath == "/artworks/oldMasters") {
      //   title = "Old Masters";
      // } else
      if (this.$route.fullPath == '/artworks/deaccession') {
        title = 'Deaccessioned'
      } else if (this.$route.fullPath == '/artworks/collection') {
        title = 'TBA21 Collection'
      } else if (this.$route.fullPath == '/artworks/pacFvh') {
        title = 'Private Art Collection FTB'
      } else if (this.$route.fullPath == '/artworks/pdcFvh') {
        title = 'Private Design Collection FTB'
      } else if (this.$route.fullPath == '/artworks/pdcFvh') {
        title = 'Private Collection FT'
      } else if (this.$route.fullPath == '/artworks/pcFT') {
        title = 'Private Art Collection MR'
      }
      return title
    },
    columns() {
      return this.$store.state.artworkColumns
    },
    processedArtists() {
      let artists = this.resultsArtists
      this.artists.map((artist) => {
        let a = artist
        artist.first_name = a ? a.first_name : 'nema meno'
      })
      return artists
    },
    storedData() {
      let sdata = ''
      if (this.$store.state.filterResults) {
        sdata = this.$store.state.filterResults
      } else {
        sdata = this.filteredData
        // console.log(sdata)
        this.$store.dispatch('postFilterResults', sdata)
      }
      this.displayedData = sdata
      return sdata
    },
    filteredData() {
      let searchString = this.filteredTextArtwork

      if (this.filteredTextArtwork != '') {
        // vráť z "this.processedArtists" dáta odfiltrované funkciou, ktorej odovzdáš každú položku poľa "this.processedArtists"
        return this.processedArtists.filter(function (artist) {
          // vráť z "artist.artworks" dáta odfiltrované funkciou, ktorej odovzdáš každú položku poľa "artist.artworks" v premennej "q"
          return (
            artist.artworks.filter(function (artwork) {
              // vráť (čítať odzadu) true - ak "title" atribút obsahuje "search" string
              return (
                artwork.title
                  .toLowerCase()
                  .indexOf(searchString.toLowerCase()) > -1
              )
            }).length > 0
          )
        })
      } else {
        return this.processedArtists
      }
    },
    filteredArtworks: function () {
      var self = this
      // console.log(self)
      // return self.artworks.filter(function (artwork) {
      //   return artwork.ownership.indexOf(self.searchQuery) == -1
      // })
      // var self = this
      self.artworks.filter(function (artwork) {
        // console.log(artwork)
        var searchRegex = new RegExp(4, 'i')
        // console.log(searchRegex)
        return searchRegex.test(artwork.ownership)
      })
    },

    // processedArtworks () {
    //   let artworks = this.resultsArtworks
    //   this.artworks.map(artwork => {
    //     let a = artwork
    //     artwork.first_name = a ? a.first_name : 'nema meno'
    //   })
    //   return artworks
    // },
    // filteredArtworks () {
    //   return this.artworks
    //     .filter(this.artworkPassesOwnershipFilter)
    // },

    // return this.processedArtists.filter(function(obj) {
    //   return obj.artworks.title(function(item){
    //     return item.indexOf('a') >= 0;
    //   });
    // });
    // function getResult(filterBy, objList) {
    //   return objList.hightlights.filter(function(obj) {
    //   return obj.queries.some(function(item){
    //     return item.indexOf(filterBy) >= 0;
    //   });
    // });
    // }
    //   const x = 'title',
    //     filter = new RegExp(this.filteredText, 'i')
    //   return this.processedArtists.filter(el => {
    //     if (el[x] !== undefined) { return el[x].match(filter) }
    //     else return true;
    //   })
    // }
  },
  // filters: {
  //   capitalize: function (a) {
  //     if (!a) return ''
  //     a = a.toString()
  //     return a.charAt(0).toUpperCase() + a.slice(1)
  //   }
  // },
  // components: {
  //   ListRelated,
  //   ListActionMenu,
  // },
}
</script>

<style scoped>
/* h2 {
  padding: 20px 0 0 20px;
  font-weight: 100px;
} */
/* a:hover {text-decoration:underline;} */
/* table.v-table tbody td, table.v-table tbody th {
    height: 110px;
} */
table.v-table thead td:not(:nth-child(1)),
table.v-table tbody td:not(:nth-child(1)),
table.v-table thead th:not(:nth-child(1)),
table.v-table tbody th:not(:nth-child(1)),
table.v-table thead td:first-child,
table.v-table tbody td:first-child,
table.v-table thead th:first-child,
table.v-table tbody th:first-child {
  padding: 0px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/todos/Index.vue